var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7498C15.3089 18.7498 17.9999 16.0589 17.9999 12.7499C17.9999 9.44092 15.3089 6.74995 12 6.74995C8.69101 6.74995 6.00004 9.44092 6.00004 12.7499C6.00004 16.0589 8.69101 18.7498 12 18.7498ZM12 9.74992C13.6545 9.74992 14.9999 11.0954 14.9999 12.7499C14.9999 14.4044 13.6545 15.7499 12 15.7499C10.3455 15.7499 9.00001 14.4044 9.00001 12.7499C9.00001 11.0954 10.3455 9.74992 12 9.74992Z",
    fill: "#23A6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.13 30.4707C11.3839 30.652 11.688 30.7494 12 30.7494C12.312 30.7494 12.6161 30.652 12.87 30.4707C13.326 30.1482 24.0434 22.4098 23.9999 12.7499C23.9999 6.13344 18.6164 0.75 12 0.75C5.38357 0.75 0.000132055 6.13344 0.000132055 12.7424C-0.0433675 22.4098 10.674 30.1482 11.13 30.4707ZM12 3.74997C16.9634 3.74997 20.9999 7.78642 20.9999 12.7574C21.0314 19.4143 14.418 25.3917 12 27.3522C9.58353 25.3902 2.9686 19.4113 3.0001 12.7499C3.0001 7.78642 7.03655 3.74997 12 3.74997Z",
    fill: "#23A6F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxMap);
export default __webpack_public_path__ + "static/media/bx_bx-map.52469c6c3251387f490826c868bad79e.svg";
export { ForwardRef as ReactComponent };